// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3mofm","overflowing":"ReadFullNote_overflowing__3ly0A"};